export default __webpack_public_path__ + "static/char-s-42-en-e6e337cd187e7f08a1872d183aeedd75.webp";